import { httpRequest } from '../request';

//
export function getSiteRedirect() {
  return httpRequest({
    url: 'common/site/redirect',
    method: 'post'
  });
}
// 自动获取ip并解析所在国家、省份、城市
export function getIpInfo() {
  return httpRequest({
    url: 'common/ip/analysis',
    method: 'post'
  });
}
